import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="mt-20 border-t border-primary-800/60 bg-primary-950">
      <div className="mx-auto w-full max-w-[1360px] px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-film-line text-xl"></i>
              </span>
              <div className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold text-foreground-950">韩国三级电影</span>
                <span className="mt-1 font-label text-[10px] uppercase tracking-[0.28em] text-primary-300">
                  Korean Film Archive
                </span>
              </div>
            </div>
            <p className="mt-5 max-w-md text-sm leading-relaxed text-primary-200/80">
              一个专注韩国影视作品资料整理的独立站点。我们收录影片背景、主创信息、剧情解析与观众评论摘要，帮助你在一部片子里看见更多层次。
            </p>
            <div className="mt-6 inline-flex items-center gap-2 rounded-full border border-accent-500/40 bg-accent-500/10 px-3 py-1.5">
              <span className="flex h-5 w-5 items-center justify-center rounded-full bg-accent-500 font-label text-[10px] font-bold text-background-50">
                18
              </span>
              <span className="text-xs text-accent-200">本站内容仅面向成年观众，请理性浏览</span>
            </div>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-label text-xs uppercase tracking-[0.24em] text-primary-300">
              快速导航
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/" className="text-primary-100/80 transition-colors hover:text-accent-300">首页</Link></li>
              <li><Link to="/category" className="text-primary-100/80 transition-colors hover:text-accent-300">影片分类</Link></li>
              <li><Link to="/search" className="text-primary-100/80 transition-colors hover:text-accent-300">搜索影片</Link></li>
              <li><Link to="/about" className="text-primary-100/80 transition-colors hover:text-accent-300">关于我们</Link></li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="font-label text-xs uppercase tracking-[0.24em] text-primary-300">
              内容分类
            </h4>
            <ul className="mt-4 space-y-3 text-sm">
              <li><Link to="/category?c=new" className="text-primary-100/80 transition-colors hover:text-accent-300">最新上映</Link></li>
              <li><Link to="/category?c=classic" className="text-primary-100/80 transition-colors hover:text-accent-300">经典收藏</Link></li>
              <li><Link to="/category?c=hot" className="text-primary-100/80 transition-colors hover:text-accent-300">热门推荐</Link></li>
              <li><Link to="/category?c=by-year" className="text-primary-100/80 transition-colors hover:text-accent-300">按年份浏览</Link></li>
            </ul>
          </div>

          <div className="md:col-span-3">
            <h4 className="font-label text-xs uppercase tracking-[0.24em] text-primary-300">
              内容声明
            </h4>
            <ul className="mt-4 space-y-3 text-sm leading-relaxed text-primary-100/70">
              <li>本站不提供任何在线播放或下载服务。</li>
              <li>全部影片资料为演示用途整理，仅用于内容展示。</li>
              <li>如涉及版权问题，请通过关于页面与我们联系。</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-800/60 pt-6 text-xs text-primary-300/80 sm:flex-row sm:items-center sm:justify-between">
          <p>© 2026 韩国三级电影 · 影视资料与影评整理站</p>
          <p className="whitespace-nowrap font-label uppercase tracking-[0.2em] text-primary-400/70">
            For Adults Only · 18+
          </p>
        </div>
      </div>
    </footer>
  );
}